const translations = {
  en: {
    "nav.home": "Home",
    "nav.features": "Features",
    "nav.pricing": "Products",
    "nav.contact": "Contact",
    "nav.documentation": "Documentation",

    "hero.title": "Standardize AI Data Integration with MCP",
    "hero.subtitle": "GuGuData provides a unified protocol for connecting large language models to specialized data sources, enhancing AI capabilities through seamless integration.",
    "hero.cta": "Try It Now",

    "features.title": "The Power of MCP Protocol",
    "features.subtitle": "Discover how MCP can transform your AI applications by standardizing data access across all sources.",
    "features.card1.title": "Seamless Integration",
    "features.card1.description": "Connect any data source to your LLM with minimal code changes, using our standardized protocol.",
    "features.card2.title": "Modular Architecture",
    "features.card2.description": "Add and remove data sources on demand, enabling your AI to access exactly what it needs.",
    "features.card3.title": "Enhanced Context",
    "features.card3.description": "Give your AI models the specialized data they need to deliver more relevant, accurate responses.",
    "features.integration.title": "How MCP Integration Works",
    "features.integration.subtitle": "Get started with MCP in three simple steps",
    "features.integration.step1.title": "Connect Your Data",
    "features.integration.step1.description": "Easily connect your existing data sources through our standardized MCP protocol interface.",
    "features.integration.step2.title": "Configure Integration",
    "features.integration.step2.description": "Set up data mapping and transformation rules with our intuitive configuration tools.",
    "features.integration.step3.title": "Enhance Your AI",
    "features.integration.step3.description": "Your AI applications now have seamless access to all connected data sources.",
    "features.standardized.title": "Standardized Protocol",
    "features.standardized.description": "MCP provides a standardized way for AI models to interact with various data sources and tools, creating a common framework that simplifies integration.",
    "features.standardized.list.item1": "Consistent data formatting across platforms",
    "features.standardized.list.item2": "Reduced development complexity",
    "features.standardized.list.item3": "Universal compatibility between models and data sources",
    "features.modular.title": "Modular Integration",
    "features.modular.description": "The MCP architecture allows developers to easily plug in different data sources as modular components, enhancing your AI's capabilities on demand.",
    "features.modular.list.item1": "Plug-and-play data source integration",
    "features.modular.list.item2": "Easy switching between different LLM providers",
    "features.modular.list.item3": "Scalable architecture that grows with your needs",
    "features.cta.title": "Ready to supercharge your AI?",
    "features.cta.description": "Join the growing ecosystem of companies using MCP protocol to connect their data to AI systems.",
    "features.cta.button": "Contact Us",

    "products.title": "Our Products",
    "products.subtitle": "Explore our MCP implementation solutions for enhancing your AI capabilities.",
    "products.card1.title": "MCP Core API",
    "products.card1.description": "Our flagship API service that enables seamless integration between LLMs and data sources. Connect once to our API and gain access to all compatible data providers.",
    "products.card1.cta": "View Documentation",
    "products.card2.title": "MCP Data Connectors",
    "products.card2.description": "Pre-built connectors for popular data sources and specialized knowledge bases. Simply enable the ones you need to enhance your AI capabilities.",
    "products.card2.cta": "Explore Connectors",

    "footer.copyright": "&copy;&nbsp;2025 GuGuData.AI. All rights reserved.",
    "footer.address": "Address",
    "footer.contact": "Contact",
    "footer.legal": "Terms of Service",
    "footer.privacy": "Privacy Policy",

    // Adding chat-related translations
    "chat.tryExamples": "Try these examples:",
    "chat.example1": "What is the next solar term in the 24 solar terms?",
    "chat.example2": "List the names of top 10 Project 211 universities in Jiangsu Province.",
    "chat.example3": "Show me the real-time basic information of A-share stock 600000.",
    "chat.example4": "Tell me the top 5 universities in the latest QS World University Rankings.",
    "chat.placeholder": "Ask about MCP data integration...",
    "chat.title": "Ask GuGuData AI with MCP",
    "chat.description": "Experience the power of MCP connectors. Toggle plugins above to enhance AI capabilities with specialized data sources.",

    "contact.title": "Contact Us",
    "contact.subtitle": "Get in touch with our team",
    "contact.sections.coreAdvantages": "Core Advantages",
    "contact.sections.technicalFeatures": "Technical Features",
    "contact.sections.solutions": "Solutions",
    "contact.intro.paragraph1":
      "Founded in 2015, GuGuData has evolved from a data management solution into a comprehensive data hub. Our mission is to empower businesses with seamless access to specialized data through our innovative MCP protocol.",
    "contact.intro.paragraph2":
      "Seamless integration capabilities with minimal code changes. Connect any data source to your LLM through our standardized protocol, optimizing enterprise data storage and performance.",
    "contact.intro.paragraph3":
      "Modular architecture with on-demand data source management. Our categorized interfaces provide versatile solutions across various domains for businesses and researchers.",
    "contact.intro.paragraph4": "Comprehensive toolkit for data processing, including PDF generation, content extraction, and SSL parsing. An ideal solution for both startups and enterprises.",
    "contact.intro.paragraph5": "We've recently launched internationalized sites and APIs, expanding our reach and making our data solutions accessible to a global audience.",
    "contact.intro.paragraph6": "For any data needs, inquiries, feedback, or partnership opportunities, feel free to reach out to us.",
    "contact.info.title": "Contact Information",
    "contact.info.email": "Email",
    "contact.info.address": "1111B S Governors Ave STE 3590\nDover, DE 19904, United States",
    "contact.info.company": "GuGuData, LLC",

    "plugins.financial.title": "Financial Data",
    "plugins.financial.description": "Access real-time financial market data and analysis tools",
    "plugins.education.title": "Educational Resources",
    "plugins.education.description": "Connect to educational databases and learning materials",
    "plugins.lunar.title": "Lunar Data",
    "plugins.lunar.description": "Get information about lunar calendar and festivals",
    "plugins.weather.title": "Weather",
    "plugins.weather.description": "Access real-time weather data and forecasts",
    "plugins.title": "MCP Plugins",
    "plugins.coming_soon.description": "Currently only some plugins are available in playground. Please refer to documentation for subscription to use all plugins.",

    // Plugin Categories
    "plugins.text.title": "NLP",
    "plugins.text.description": "Natural language processing and text analysis tools",
    "plugins.image.title": "PDF Tools",
    "plugins.image.description": "Image processing and PDF handling tools",
    "plugins.news.title": "News",
    "plugins.news.description": "News and information aggregation services",
    "plugins.finance.title": "Finance",
    "plugins.finance.description": "Basic financial data and analysis tools",
    "plugins.business.title": "Business",
    "plugins.business.description": "Business intelligence and analytics tools",
    "plugins.location.title": "Location",
    "plugins.location.description": "Geographic and coordinate-based services",
    "plugins.webtools.title": "Web Tools",
    "plugins.webtools.description": "Various web-based utilities and tools",
    "plugins.ai.title": "AI Models",
    "plugins.ai.description": "AI models and machine learning services",
    "plugins.barcode.title": "Barcode",
    "plugins.barcode.description": "Barcode generation and scanning utilities",
    "plugins.sms.title": "SMS",
    "plugins.sms.description": "SMS and voice communication services",

    "meta.contact.title": "Contact Us - GuGuData",
    "meta.contact.description": "GuGuData offers professional data services and MCP protocol integration. Contact us to learn more about our data services, API integration, and customized solutions.",
    "meta.contact.keywords": "GuGuData, MCP, data services, API integration, contact",
    "meta.home.title": "GuGuData | Standardize AI Data Integration with MCP",
    "meta.home.description": "GuGuData provides a unified protocol for connecting large language models to specialized data sources, enhancing AI capabilities through seamless integration.",
    "meta.home.keywords": "GuGuData, MCP, AI integration, data services, LLM, language models",
    "meta.products.title": "Our Products - GuGuData",
    "meta.products.description": "Explore our MCP implementation solutions for enhancing your AI capabilities. Discover our core API and data connectors.",
    "meta.products.keywords": "GuGuData, MCP, API, data connectors, AI solutions, integration",
    "meta.documentation.title": "Documentation - GuGuData.AI | MCP Protocol for AI Data Integration",
    "meta.documentation.description": "Comprehensive documentation for GuGuData's MCP protocol. Learn how to integrate specialized data sources with your AI applications.",
    "meta.documentation.keywords": "GuGuData, MCP documentation, API reference, data integration, getting started, implementation guide",
    "notfound.title": "404 - Page Not Found",
    "notfound.description": "Oops! The page you're looking for doesn't exist.",
    "notfound.backHome": "Return to Home",

    "documentation.title": "Documentation",
    "documentation.introduction": "Introduction",
    "documentation.getting-started": "Getting Started",
    "documentation.features": "Features",
    "documentation.api": "API Reference",
    "documentation.examples": "Examples",
    "documentation.troubleshooting": "Troubleshooting",

    "documentation.introduction.welcome":
      "Welcome to the GuGuData MCP Protocol documentation. Here you'll find comprehensive guides and documentation to help you start working with GuGuData MCP as quickly as possible, as well as support if you get stuck.",
    "documentation.introduction.how_it_works.title": "How it Works",
    "documentation.introduction.how_it_works.description":
      "GuGuData provides a unified protocol for connecting large language models to specialized data sources. When you send a query to our API, our backend automatically loads the MCP plugins that you've purchased and configured with your API key, making them available to the model for processing your request.",
    "documentation.introduction.mcp_plugins.title": "MCP Plugins",
    "documentation.introduction.mcp_plugins.description":
      "MCP plugins enhance AI capabilities by providing specialized knowledge and data processing abilities. Purchase and configure plugins through our website to use them with your API key.",
    "documentation.introduction.mcp_plugins.chinese": "Chinese Website",
    "documentation.introduction.mcp_plugins.international": "English & Japanese Website",
    "documentation.introduction.note": "Your API key is associated with your purchased plugins. Keep your API key secure and do not share it with others.",

    "documentation.api.baseurl.title": "Base URL",
    "documentation.api.example.title": "Example Request",

    "documentation.getting-started.content": "To get started, you'll need to obtain an API key from our website and purchase the MCP plugins that match your needs.",
    "documentation.features.content": "Explore the various features of GuGuData MCP Protocol including automatic plugin loading, multilingual support, and specialized data sources.",
    "documentation.api.content":
      "Our API follows standard practices for RESTful services. All API endpoints are prefixed with 'https://api.gugudata.ai/v1' and require authentication using your API key.",
    "documentation.examples.content": "Check out these examples to learn how to integrate with different data sources using the MCP protocol.",
    "documentation.troubleshooting.content": "Find solutions to common issues and learn how to troubleshoot problems with your MCP implementation.",

    "documentation.api.authentication.title": "Authentication",
    "documentation.api.authentication.description":
      "All API requests require authentication using your GuGuData AI API key. You will need to include your API key in the Authorization header of all requests.",
    "documentation.api.authentication.header": "Authorization Header",
    "documentation.api.authentication.note": "Replace <GuGuData AI API Key> with your actual API key. Keep your API key secure and do not expose it in client-side code.",

    "documentation.api.endpoints.title": "Endpoints",
    "documentation.api.endpoints.parameter": "Parameter",
    "documentation.api.endpoints.type": "Type",
    "documentation.api.endpoints.required": "Required",
    "documentation.api.endpoints.description": "Description",
    "documentation.api.endpoints.yes": "Yes",
    "documentation.api.endpoints.no": "No",
    "documentation.api.endpoints.example_request": "Example Request",
    "documentation.api.endpoints.example_response": "Example Response",

    "documentation.api.endpoints.chat_completions.title": "Create Chat Completion",
    "documentation.api.endpoints.chat_completions.description": "Creates a completion for the chat message",
    "documentation.api.endpoints.chat_completions.params.title": "Request Parameters",
    "documentation.api.endpoints.chat_completions.params.model": "ID of the model to use. Currently only 'gugudata-chat' is supported.",
    "documentation.api.endpoints.chat_completions.params.messages": "A list of messages comprising the conversation so far.",
    "documentation.api.endpoints.chat_completions.params.stream": "If set to true, partial message deltas will be sent, like in ChatGPT. Defaults to false.",

    "contact.slack": "Contact us on Slack",
    "documentation.slack.support": "Get Support on Slack",
  },

  zh: {
    "nav.home": "首页",
    "nav.features": "功能",
    "nav.pricing": "产品",
    "nav.contact": "联系我们",
    "nav.documentation": "文档",

    "hero.title": "使用 MCP 标准化 AI 数据集成",
    "hero.subtitle": "GuGuData 提供统一协议，连接大型语言模型与专业数据源，通过无缝集成增强 AI 能力。",
    "hero.cta": "立即体验",

    "features.title": "MCP 协议的强大功能",
    "features.subtitle": "了解 MCP 如何通过标准化所有数据源的访问方式，改变您的 AI 应用程序。",
    "features.card1.title": "无缝集成",
    "features.card1.description": "使用我们的标准协议，只需少量代码更改即可将任何数据源连接到您的 LLM。",
    "features.card2.title": "模块化架构",
    "features.card2.description": "按需添加和移除数据源，使您的 AI 能够精确访问所需内容。",
    "features.card3.title": "增强上下文",
    "features.card3.description": "为您的 AI 模型提供所需的专业数据，以提供更相关、更准确的响应。",
    "features.integration.title": "MCP 集成流程",
    "features.integration.subtitle": "通过三个简单步骤开始使用 MCP",
    "features.integration.step1.title": "连接数据",
    "features.integration.step1.description": "通过我们的标准化 MCP 协议接口轻松连接您现有的数据源。",
    "features.integration.step2.title": "配置集成",
    "features.integration.step2.description": "使用我们直观的配置工具设置数据映射和转换规则。",
    "features.integration.step3.title": "增强 AI",
    "features.integration.step3.description": "您的 AI 应用程序现在可以无缝访问所有连接的数据源。",
    "features.standardized.title": "标准化协议",
    "features.standardized.description": "MCP 为 AI 模型提供了一种标准化的方式来与各种数据源和工具交互，创建了一个简化集成的通用框架。",
    "features.standardized.list.item1": "跨平台的一致数据格式",
    "features.standardized.list.item2": "降低开发复杂度",
    "features.standardized.list.item3": "模型和数据源之间的通用兼容性",
    "features.modular.title": "模块化集成",
    "features.modular.description": "MCP 架构允许开发人员轻松插入不同的数据源作为模块化组件，按需增强您的 AI 能力。",
    "features.modular.list.item1": "即插即用的数据源集成",
    "features.modular.list.item2": "轻松切换不同的 LLM 提供商",
    "features.modular.list.item3": "可随需求增长的可扩展架构",
    "features.cta.title": "准备好提升您的 AI 能力了吗？",
    "features.cta.description": "加入使用 MCP 协议连接数据的企业生态系统。",
    "features.cta.button": "联系我们",

    "products.title": "我们的产品",
    "products.subtitle": "探索我们的 MCP 实施解决方案，增强您的 AI 能力。",
    "products.card1.title": "MCP 核心 API",
    "products.card1.description": "我们的旗舰 API 服务，实现 LLM 与数据源之间的无缝集成。只需连接一次我们的 API，即可访问所有兼容的数据提供商。",
    "products.card1.cta": "查看文档",
    "products.card2.title": "MCP 数据连接器",
    "products.card2.description": "为流行数据源和专业知识库预构建的连接器。只需启用您需要的连接器，即可增强 AI 功能。",
    "products.card2.cta": "探索连接器",

    "footer.copyright": "&copy;&nbsp;2025 GuGuData.AI. 保留所有权利。",
    "footer.address": "地址",
    "footer.contact": "联系方式",
    "footer.legal": "服务条款",
    "footer.privacy": "隐私政策",

    "chat.tryExamples": "尝试这些示例：",
    "chat.example1": "你能告诉我下一个二十四节气是什么吗？",
    "chat.example2": "给我江苏省前十个 211 大学，给我大学的名字就可以了。",
    "chat.example3": "你能告诉我 A 股股票 600000 目前实时的基本信息吗？",
    "chat.example4": "告诉我实时的全球 QS 世界大学排名前 5 的大学。",
    "chat.placeholder": "询问有关 MCP 数据集成的问题...",
    "chat.title": "使用 MCP 询问 GuGuData AI",
    "chat.description": "体验 MCP 连接器的强大功能。切换上方的插件以通过专业数据源增强 AI 能力。",

    "contact.title": "联系我们",
    "contact.subtitle": "与我们的团队取得联系",
    "contact.sections.coreAdvantages": "核心优势",
    "contact.sections.technicalFeatures": "技术特点",
    "contact.sections.solutions": "解决方案",
    "contact.intro.paragraph1": "GuGuData 成立于 2015 年，已从数据管理解决方案发展成为全面的数据中心。我们的使命是通过创新的 MCP 协议为企业提供无缝访问专业数据的能力。",
    "contact.intro.paragraph2": "通过我们的标准化协议，只需少量代码更改即可实现无缝集成能力。连接任何数据源到您的 LLM，优化企业数据存储和性能。",
    "contact.intro.paragraph3": "具有按需数据源管理的模块化架构。我们的分类接口为企业和研究人员提供跨领域的多样化解决方案。",
    "contact.intro.paragraph4": "全面的数据处理工具包，包括 PDF 生成、内容提取和 SSL 解析。适合初创企业和大型企业的理想解决方案。",
    "contact.intro.paragraph5": "我们最近推出了国际化站点和 API，扩大了我们的覆盖范围，使我们的数据解决方案可供全球用户使用。",
    "contact.intro.paragraph6": "如有任何数据需求、咨询、反馈或合作机会，请随时与我们联系。",
    "contact.info.title": "联系信息",
    "contact.info.email": "邮箱",
    "contact.info.address": "1111B S Governors Ave STE 3590\nDover, DE 19904, United States",
    "contact.info.company": "GuGuData, LLC",

    "plugins.financial.title": "金融数据",
    "plugins.financial.description": "访问实时金融市场数据和分析工具",
    "plugins.education.title": "教育资源",
    "plugins.education.description": "连接教育数据库和学习材料",
    "plugins.lunar.title": "农历数据",
    "plugins.lunar.description": "获取农历和节日信息",
    "plugins.weather.title": "天气",
    "plugins.weather.description": "访问实时天气数据和预报",
    "plugins.title": "MCP 插件",
    "plugins.coming_soon.description": "目前 playground 只开放了部分 plugins，可参阅 documentation 订阅购买使用所有 plugins。",

    "plugins.text.title": "NLP",
    "plugins.text.description": "自然语言处理和文本分析工具",
    "plugins.image.title": "PDF 工具",
    "plugins.image.description": "图像处理和 PDF 处理工具",
    "plugins.news.title": "新闻",
    "plugins.news.description": "新闻和信息聚合服务",
    "plugins.finance.title": "金融",
    "plugins.finance.description": "基础金融数据和分析工具",
    "plugins.business.title": "商业",
    "plugins.business.description": "商业智能和分析工具",
    "plugins.location.title": "位置",
    "plugins.location.description": "地理和基于坐标的服务",
    "plugins.webtools.title": "网页工具",
    "plugins.webtools.description": "各种网络实用工具",
    "plugins.ai.title": "AI 模型",
    "plugins.ai.description": "人工智能模型和机器学习服务",
    "plugins.barcode.title": "条码",
    "plugins.barcode.description": "条码生成和扫描工具",
    "plugins.sms.title": "短信",
    "plugins.sms.description": "短信和语音通信服务",

    "meta.contact.title": "联系我们 - GuGuData",
    "meta.contact.description": "GuGuData 提供专业的数据服务和 MCP 协议集成。联系我们了解更多关于数据服务、API 集成和定制化解决方案的信息。",
    "meta.contact.keywords": "GuGuData, MCP, 数据服务, API 集成, 联系我们",
    "meta.home.title": "GuGuData | 使用 MCP 标准化 AI 数据集成",
    "meta.home.description": "GuGuData 提供统一协议，连接大型语言模型与专业数据源，通过无缝集成增强 AI 能力。",
    "meta.home.keywords": "GuGuData, MCP, AI 集成, 数据服务, 大语言模型, 语言模型",
    "meta.products.title": "我们的产品 - GuGuData",
    "meta.products.description": "探索我们的 MCP 实施解决方案，增强您的 AI 能力。了解我们的核心 API 和数据连接器。",
    "meta.products.keywords": "GuGuData, MCP, API, 数据连接器, AI 解决方案, 集成",
    "meta.documentation.title": "文档 - GuGuData.AI | AI 数据集成的 MCP 协议",
    "meta.documentation.description": "GuGuData MCP 协议的综合文档。了解如何将专业数据源与您的 AI 应用程序集成。",
    "meta.documentation.keywords": "GuGuData, MCP 文档, API 参考, 数据集成, 入门指南, 实施指南",
    "notfound.title": "404 - 页面未找到",
    "notfound.description": "抱歉！您访问的页面不存在。",
    "notfound.backHome": "返回首页",

    "documentation.title": "文档",
    "documentation.introduction": "介绍",
    "documentation.getting-started": "快速开始",
    "documentation.features": "功能特性",
    "documentation.api": "API 参考",
    "documentation.examples": "示例",
    "documentation.troubleshooting": "故障排除",

    "documentation.introduction.welcome": "欢迎来到 GuGuData MCP 协议文档。在这里，您将找到全面的指南和文档，帮助您尽快开始使用 GuGuData MCP，以及在遇到问题时获取支持。",
    "documentation.introduction.how_it_works.title": "工作原理",
    "documentation.introduction.how_it_works.description":
      "GuGuData 提供统一协议，连接大型语言模型与专业数据源。当您向我们的 API 发送查询时，我们的后端会自动加载您已购买并配置的 MCP 插件，使模型能够使用这些插件处理您的请求。",
    "documentation.introduction.mcp_plugins.title": "MCP 插件",
    "documentation.introduction.mcp_plugins.description": "MCP 插件通过提供专业知识和数据处理能力来增强 AI 的功能。通过我们的网站购买并配置插件，以便将其与您的 API 密钥一起使用。",
    "documentation.introduction.mcp_plugins.chinese": "中文网站",
    "documentation.introduction.mcp_plugins.international": "英文和日文网站",
    "documentation.introduction.note": "您的 API 密钥与已购买的插件相关联。请保管好您的 API 密钥，不要与他人共享。",

    "documentation.api.baseurl.title": "基础 URL",
    "documentation.api.example.title": "请求示例",

    "documentation.getting-started.content": "要开始使用，您需要从我们的网站获取 API 密钥，并购买符合您需求的 MCP 插件。",
    "documentation.features.content": "探索 GuGuData MCP 协议的各种功能，包括自动加载插件、多语言支持和专业数据源。",
    "documentation.api.content": "我们的 API 遵循 RESTful 服务的标准实践。所有 API 端点都以 'https://api.gugudata.ai/v1' 为前缀，并需要使用您的 API 密钥进行身份验证。",
    "documentation.examples.content": "查看这些示例，了解如何使用 MCP 协议与不同数据源集成。",
    "documentation.troubleshooting.content": "查找常见问题的解决方案，并了解如何排除 MCP 实施中的问题。",

    "documentation.api.authentication.title": "身份验证",
    "documentation.api.authentication.description": "所有 API 请求都需要使用您的 GuGuData AI API 密钥进行身份验证。您需要在所有请求的 Authorization 头中包含您的 API 密钥。",
    "documentation.api.authentication.header": "Authorization 头",
    "documentation.api.authentication.note": "将 <GuGuData AI API Key> 替换为您的实际 API 密钥。请妥善保管您的 API 密钥，不要在客户端代码中暴露。",

    "documentation.api.endpoints.title": "端点",
    "documentation.api.endpoints.parameter": "参数",
    "documentation.api.endpoints.type": "类型",
    "documentation.api.endpoints.required": "必需",
    "documentation.api.endpoints.description": "描述",
    "documentation.api.endpoints.yes": "是",
    "documentation.api.endpoints.no": "否",
    "documentation.api.endpoints.example_request": "请求示例",
    "documentation.api.endpoints.example_response": "响应示例",

    "documentation.api.endpoints.chat_completions.title": "创建聊天完成",
    "documentation.api.endpoints.chat_completions.description": "为聊天消息创建完成",
    "documentation.api.endpoints.chat_completions.params.title": "请求参数",
    "documentation.api.endpoints.chat_completions.params.model": "要使用的模型 ID。目前仅支持 'gugudata-chat'。",
    "documentation.api.endpoints.chat_completions.params.messages": "包含对话的消息列表。",
    "documentation.api.endpoints.chat_completions.params.stream": "如果设置为 true，将发送部分消息增量，类似于 ChatGPT。默认为 false。",

    "contact.slack": "在 Slack 上联系我们",
    "documentation.slack.support": "在 Slack 上获取支持",
  },

  ja: {
    "nav.home": "ホーム",
    "nav.features": "機能",
    "nav.pricing": "製品",
    "nav.contact": "お問い合わせ",
    "nav.documentation": "ドキュメント",

    "hero.title": "MCPでAIデータ統合を標準化",
    "hero.subtitle": "GuGuData は、大規模言語モデルと専門データソースを接続するための統一プロトコルを提供し、シームレスな統合により AI 機能を強化します。",
    "hero.cta": "今すぐ試す",

    "features.title": "MCPプロトコルのパワー",
    "features.subtitle": "MCP がすべてのデータソースへのアクセスを標準化することで、AI アプリケーションをどのように変革できるかをご覧ください。",
    "features.card1.title": "シームレスな統合",
    "features.card1.description": "標準化されたプロトコルを使用して、最小限のコード変更で任意のデータソースを LLM に接続します。",
    "features.card2.title": "モジュラーアーキテクチャ",
    "features.card2.description": "データソースをオンデマンドで追加および削除し、AI が必要とするものに正確にアクセスできるようにします。",
    "features.card3.title": "強化されたコンテキスト",
    "features.card3.description": "AI モデルに必要な専門データを提供し、より関連性の高い正確な応答を提供します。",
    "features.integration.title": "MCP 統合のしくみ",
    "features.integration.subtitle": "MCP を使用するための 3 つの簡単な手順",
    "features.integration.step1.title": "データの接続",
    "features.integration.step1.description": "標準化された MCP プロトコルインターフェースを介して、既存のデータソースを簡単に接続します。",
    "features.integration.step2.title": "統合の設定",
    "features.integration.step2.description": "データマッピングと変換ルールを設定するために、直感的な設定ツールを使用します。",
    "features.integration.step3.title": "AI の強化",
    "features.integration.step3.description": "AI アプリケーションは、すべての接続データソースにシームレスにアクセスできるようになりました。",
    "features.standardized.title": "標準化されたプロトコル",
    "features.standardized.description":
      "MCP は、AI モデルがさまざまなデータソースとツールとの間でシームレスにやり取りするための標準化された方法を提供し、統合を簡単にする共通のフレームワークを作成します。",
    "features.standardized.list.item1": "異なるプラットフォーム間の一貫したデータ形式",
    "features.standardized.list.item2": "開発の複雑さの削減",
    "features.standardized.list.item3": "モデルとデータソース間の一般的な互換性",
    "features.modular.title": "モジュラー統合",
    "features.modular.description": "MCP アーキテクチャは、開発者が異なるデータソースをモジュラーコンポーネントとして簡単に挿入できるようにすることで、AI の能力を必要に応じて強化します。",
    "features.modular.list.item1": "即座にデータソースを統合する",
    "features.modular.list.item2": "異なる LLM プロバイダー間の簡単な切り替え",
    "features.modular.list.item3": "必要に応じて拡張可能なアーキテクチャ",
    "features.cta.title": "AI を強化する準備はできていますか？",
    "features.cta.description": "MCP プロトコルを使用してデータを AI システムに接続する企業のエコシステムに参加します。",
    "features.cta.button": "お問い合わせ",

    "products.title": "当社の製品",
    "products.subtitle": "AI 機能を強化するための MCP 実装ソリューションをご覧ください。",
    "products.card1.title": "MCPコアAPI",
    "products.card1.description":
      "LLM とデータソース間のシームレスな統合を可能にする当社のフラッグシップ API サービス。当社の API に一度接続するだけで、互換性のあるすべてのデータプロバイダーにアクセスできます。",
    "products.card1.cta": "ドキュメントを見る",
    "products.card2.title": "MCPデータコネクタ",
    "products.card2.description": "人気のデータソースと専門知識ベース用の事前構築されたコネクタ。必要なものを有効にするだけで、AI 機能を強化できます。",
    "products.card2.cta": "コネクタを探索する",

    "footer.copyright": "&copy;&nbsp;2025 GuGuData, LLC. 全著作権所有。",
    "footer.address": "住所",
    "footer.contact": "お問い合わせ",
    "footer.legal": "利用規約",
    "footer.privacy": "プライバシーポリシー",

    // Adding chat-related translations for Japanese
    "chat.tryExamples": "以下の例を試してみてください：",
    "chat.example1": "次の二十四節気は何ですか？",
    "chat.example2": "江蘇省のトップ10の211プロジェクト大学の名前を教えてください。",
    "chat.example3": "A株の銘柄600000の現在のリアルタイム基本情報を教えてください。",
    "chat.example4": "最新のQS世界大学ランキングのトップ5大学を教えてください。",
    "chat.placeholder": "MCPデータ統合について質問する...",
    "chat.title": "MCPでGuGuData AIに質問",
    "chat.description": "MCPコネクタのパワーを体験してください。上記のプラグインを切り替えて、専門データソースでAI機能を強化します。",

    "contact.title": "お問い合わせ",
    "contact.subtitle": "チームにご連絡ください",
    "contact.sections.coreAdvantages": "コアアドバンテージ",
    "contact.sections.technicalFeatures": "技術的特徴",
    "contact.sections.solutions": "ソリューション",
    "contact.intro.paragraph1":
      "2015年に設立されたGuGuDataは、データ管理ソリューションから包括的なデータハブへと成長しました。私たちの使命は、革新的なMCPプロトコルを通じて、企業に専門データへのシームレスなアクセスを提供することです。",
    "contact.intro.paragraph2":
      "当社のプラットフォームはシームレスな統合機能を備えており、最小限のコード変更で任意のデータソースをLLMに接続できます。標準化されたプロトコルを通じて、企業クライアントのデータストレージの最適化とパフォーマンスの向上を支援しています。",
    "contact.intro.paragraph3":
      "モジュラーアーキテクチャにより、データソースをオンデマンドで追加・削除でき、AIが必要とするものに正確にアクセスできます。分類されたデータと機能インターフェースは様々な分野をカバーし、アナリスト、企業、研究者、革新者向けの多用途ソリューションを提供します。",
    "contact.intro.paragraph4":
      "効率的なPDF生成、インテリジェントなコンテンツ抽出、SSL証明書情報の解析のための堅牢なツールを提供しています。当社のプラットフォームは複雑なデータセットを簡単に処理できるように設計されており、GuGuDataはスタートアップと確立された企業の両方にとって理想的なデータソリューションとなっています。",
    "contact.intro.paragraph5": "最近、国際化されたサイトとAPIをローンチし、リーチを拡大し、データソリューションをグローバルなオーディエンスにアクセス可能にしました。",
    "contact.intro.paragraph6": "データニーズ、お問い合わせ、フィードバック、パートナーシップの機会について、お気軽にお問い合わせください。",
    "contact.info.title": "お問い合わせ情報",
    "contact.info.company": "GuGuData, LLC",
    "contact.info.address": "1111B S Governors Ave STE 3590\nDover, DE 19904, United States",
    "contact.info.email": "メールアドレス",

    "plugins.financial.title": "金融データ",
    "plugins.financial.description": "リアルタイムの金融市場データと分析ツールにアクセス",
    "plugins.education.title": "教育リソース",
    "plugins.education.description": "教育データベースと学習教材に接続",
    "plugins.lunar.title": "旧暦データ",
    "plugins.lunar.description": "旧暦と祝祭日の情報を取得",
    "plugins.weather.title": "天気",
    "plugins.weather.description": "リアルタイムの天気データと予報にアクセス",
    "plugins.title": "MCP プラグイン",
    "plugins.coming_soon.description": "現在 playground では一部のプラグインのみ利用可能です。すべてのプラグインを使用するには、documentation を参照して購読してください。",

    // Plugin Categories
    "plugins.text.title": "NLP",
    "plugins.text.description": "自然言語処理とテキスト分析ツール",
    "plugins.image.title": "PDFツール",
    "plugins.image.description": "画像処理とPDF処理ツール",
    "plugins.news.title": "ニュース",
    "plugins.news.description": "ニュースと情報集約サービス",
    "plugins.finance.title": "金融",
    "plugins.finance.description": "基本的な金融データと分析ツール",
    "plugins.business.title": "ビジネス",
    "plugins.business.description": "ビジネスインテリジェンスと分析ツール",
    "plugins.location.title": "位置情報",
    "plugins.location.description": "地理と座標ベースのサービス",
    "plugins.webtools.title": "Webツール",
    "plugins.webtools.description": "様々なWebベースのユーティリティとツール",
    "plugins.ai.title": "AIモデル",
    "plugins.ai.description": "AIモデルと機械学習サービス",
    "plugins.barcode.title": "バーコード",
    "plugins.barcode.description": "バーコード生成とスキャンツール",
    "plugins.sms.title": "SMS",
    "plugins.sms.description": "SMSと音声通信サービス",

    "meta.contact.title": "お問い合わせ - GuGuData",
    "meta.contact.description": "GuGuData は専門的なデータサービスと MCP プロトコル統合を提供します。データサービス、API 統合、カスタマイズソリューションについての詳細はお問い合わせください。",
    "meta.contact.keywords": "GuGuData, MCP, データサービス, API統合, お問い合わせ",
    "meta.home.title": "GuGuData | MCPでAIデータ統合を標準化",
    "meta.home.description": "GuGuData は、大規模言語モデルと専門データソースを接続するための統一プロトコルを提供し、シームレスな統合により AI 機能を強化します。",
    "meta.home.keywords": "GuGuData, MCP, AI統合, データサービス, 大規模言語モデル, 言語モデル",
    "meta.products.title": "当社の製品 - GuGuData",
    "meta.products.description": "AI 機能を強化するための MCP 実装ソリューションをご覧ください。コア API とデータコネクタについてご紹介します。",
    "meta.products.keywords": "GuGuData, MCP, API, データコネクタ, AIソリューション, 統合",
    "meta.documentation.title": "ドキュメント - GuGuData.AI | AIデータ統合のためのMCPプロトコル",
    "meta.documentation.description": "GuGuData MCP プロトコルの包括的なドキュメント。専門データソースを AI アプリケーションと統合する方法をご覧ください。",
    "meta.documentation.keywords": "GuGuData, MCPドキュメント, APIリファレンス, データ統合, 入門ガイド, 実装ガイド",
    "notfound.title": "404 - ページが見つかりません",
    "notfound.description": "申し訳ありません！お探しのページは存在しません。",
    "notfound.backHome": "ホームに戻る",

    "documentation.title": "ドキュメント",
    "documentation.introduction": "紹介",
    "documentation.getting-started": "はじめに",
    "documentation.features": "機能特性",
    "documentation.api": "API 参考",
    "documentation.examples": "例",
    "documentation.troubleshooting": "トラブルシューティング",

    "documentation.introduction.welcome":
      "GuGuData MCP プロトコルのドキュメントへようこそ。ここでは、GuGuData MCP の使用をできるだけ早く開始するための包括的なガイドとドキュメント、および問題が発生した場合のサポートを見つけることができます。",
    "documentation.introduction.how_it_works.title": "仕組み",
    "documentation.introduction.how_it_works.description":
      "GuGuData は、大規模言語モデルを専門データソースに接続するための統一プロトコルを提供します。API にクエリを送信すると、バックエンドは購入して設定した MCP プラグインを自動的に読み込み、モデルがリクエストを処理するためにそれらを利用できるようにします。",
    "documentation.introduction.mcp_plugins.title": "MCP プラグイン",
    "documentation.introduction.mcp_plugins.description":
      "MCP プラグインは、専門知識とデータ処理機能を提供することで AI 機能を強化します。当社のウェブサイトからプラグインを購入して設定し、API キーと一緒に使用してください。",
    "documentation.introduction.mcp_plugins.chinese": "中国語ウェブサイト",
    "documentation.introduction.mcp_plugins.international": "英語・日本語ウェブサイト",
    "documentation.introduction.note": "API キーは購入したプラグインに関連付けられています。API キーを安全に保管し、他人と共有しないでください。",

    "documentation.api.baseurl.title": "ベース URL",
    "documentation.api.example.title": "リクエスト例",

    "documentation.getting-started.content": "開始するには、当社のウェブサイトから API キーを取得し、ニーズに合った MCP プラグインを購入する必要があります。",
    "documentation.features.content": "自動プラグインローディング、多言語サポート、専門データソースなど、GuGuData MCP プロトコルのさまざまな機能を探索してください。",
    "documentation.api.content":
      "当社の API は RESTful サービスの標準的な慣行に従っています。すべての API エンドポイントは 'https://api.gugudata.ai/v1' を接頭辞とし、API キーを使用した認証が必要です。",
    "documentation.examples.content": "これらの例を確認して、MCP プロトコルを使用してさまざまなデータソースと統合する方法を学びましょう。",
    "documentation.troubleshooting.content": "一般的な問題の解決策を見つけ、MCP 実装における問題のトラブルシューティング方法を学びましょう。",

    "documentation.api.authentication.title": "認証",
    "documentation.api.authentication.description":
      "すべての API リクエストには、GuGuData AI API キーを使用した認証が必要です。すべてのリクエストの Authorization ヘッダーに API キーを含める必要があります。",
    "documentation.api.authentication.header": "認証ヘッダー",
    "documentation.api.authentication.note": "<GuGuData AI API Key> を実際の API キーに置き換えてください。API キーを安全に保管し、クライアント側のコードで公開しないでください。",

    "documentation.api.endpoints.title": "エンドポイント",
    "documentation.api.endpoints.parameter": "パラメータ",
    "documentation.api.endpoints.type": "タイプ",
    "documentation.api.endpoints.required": "必須",
    "documentation.api.endpoints.description": "説明",
    "documentation.api.endpoints.yes": "はい",
    "documentation.api.endpoints.no": "いいえ",
    "documentation.api.endpoints.example_request": "リクエスト例",
    "documentation.api.endpoints.example_response": "レスポンス例",

    "documentation.api.endpoints.chat_completions.title": "チャット補完の作成",
    "documentation.api.endpoints.chat_completions.description": "チャットメッセージの補完を作成します",
    "documentation.api.endpoints.chat_completions.params.title": "リクエストパラメータ",
    "documentation.api.endpoints.chat_completions.params.model": "使用するモデルの ID。現在は 'gugudata-chat' のみがサポートされています。",
    "documentation.api.endpoints.chat_completions.params.messages": "これまでの会話を構成するメッセージのリスト。",
    "documentation.api.endpoints.chat_completions.params.stream": "true に設定すると、ChatGPT のように部分的なメッセージデルタが送信されます。デフォルトは false です。",

    "contact.slack": "Slackでお問い合わせ",
    "documentation.slack.support": "Slackでサポートを受ける",
  },
};

export default translations;
